import { LoggingContext } from "context";
import { useContext } from "react"

export const useLogger = () => {
    const { logger } = useContext(LoggingContext);

    return logger;
}